import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

import { IState } from './fastCheckout.types';

const getFastCheckoutSubscriptionStore = (state: RootState) => state.fastCheckout as IState;

export const getIsCheckoutProcessing = createSelector(getFastCheckoutSubscriptionStore, (state) => state.isCheckoutProcessing);
export const getFastCheckoutState = createSelector(
    getFastCheckoutSubscriptionStore,
    (state, id) => id,
    (state, id) => state.productState[id]
);
